module.exports = __webpack_public_path__ + "img/17.5f7a3dcd.png";